<template>
  <div>
    <slot
      name="careers-list-controls"
      :filter-categories="filterCategories"
      :on-value-chosen="onValueChosen"
      :update-search-string="updateSearchString"
      :default-query="queryObject.q"
      :items-present="items.length"
      :query-input-name="queryInputName"
      :justify="justify"
    ></slot>

      <!-- v-if="itemsPerPage < total_count"  -->
    <pager 
      :items-length="total_count" 
      :items-per-page="itemsPerPage"
      :active-index="activeIndex"
      :page-options-to-show="pageOptionsToShow"
      @page-to="pageTo"
      className="pager_borderBottom mix-pager_lightBorder"
      >
    </pager>
    <transition name="v-fade" mode="out-in">
      <div v-if="!dataIsLoaded && !items.length" class="m-positionRelative">
            <div class="loading"></div>
      </div>
    </transition>
    <transition name="v-fade" mode="out-in">
      <slot
        name="careers-list-results"
        v-if="dataIsLoaded"
        :items="items"
		:sortorder="sortorder"
		:sort-by-column="sortByColumn"
        :data-is-loaded="dataIsLoaded"
        :reset-search="resetSearch"
      >
      </slot>
    </transition>

      <!-- v-if="itemsPerPage < total_count"    (removed per request so results will show regardless)-->
    <pager 
      :items-length="total_count" 
      :items-per-page="itemsPerPage"
      :active-index="activeIndex"
      :page-options-to-show="pageOptionsToShow"
      @page-to="pageTo"
      className="pager_borderTop mix-pager_lightBorder"
      >
    </pager>

  </div>
</template>

<script>
import Pager from './Pager.vue';

import CareersSearchService from '../../service/CareersSearchService.js';
import { camelize } from '../../utilities/camelize.js';
import { debounce } from '../../utilities/debounce.js';
import { jsonToQueryString } from '../../utilities/jsonToQueryString';
import { getParams, applySpaces } from '../../utilities/getParams';

/* Single place to controls the name attribute of the search query field within CareersListFilters
(and the places it's referenced in this file). TODO: Best if sourced from BE config */
const queryInputName = 's';

export default {
  components: {
    Pager
  },
  props: {
    initialFilters: Array,
    tableHeaders: Array,
    blockColumns: {
      type: Number,
      default: 1
    },
    itemsPerPage: {
      type: Number
    },
    pageOptionsToShow: {
      type: Number,
      default: 9
    },
    justify: {
      type: String,
      default: 'center'
    }
  },
  data() {
    return {
      filterCategories: null,
      items: [],
	  sortorder: [],
      queryObject: {
        q: '',
        filterValues: {}
      },
	  sortBy: {},
      activeIndex: 0,
      total_count: 0,
      dataIsLoaded: false
    };
  },
  async created() {
    // initialize data structure for the view's usage
    this._initializeFilterCategoryOptions();

    // initialize data structure for api usage
    this._setInitialCategories(this.initialFilters);

    /* Prepopulates forms if query string values are present */
    this._extractQueryStringParams();

    // perform initial fetch
    await this.getItems();
    
  },

  methods: {
    _initializeFilterCategoryOptions() {
      this.filterCategories = this.initialFilters.map(item => {
        item.options = [];
		item.values = [];
        return item;
      });
    },

    _setInitialCategories() {
      /* Establishing empty filter values based on initial filters
      and storing them in queryObject.filterValues so we can use them in 
      our initial this.getItems() request which will populate select filters 
      with options */
      for (let i = 0; i < this.filterCategories.length; i++) {
        let key = this.filterCategories[i].name;
        // setting with empty string so the API will provide us with all options available
        this._setFilterValue(key, '');
      }
    },
    _extractQueryStringParams() {
        const queryParams = getParams(window.location)
        let filterCategories = this.filterCategories;
        if(Object.keys(queryParams).length === 0 && queryParams.constructor === Object) {
            return //No query values to prepopluate search with 
        }

        for (const key in queryParams) {
            const value = queryParams[key];
            if(key === queryInputName){
              this.setQueryValue(queryParams[key]);
              continue;
            }
            if (key.toLowerCase() !== 'id'){
              this._setFilterValue(key, value);
            }

        }

        return;
    },
    _removeQueryFromUrl() {
        const locationString = window.location.toString();
        const currentQuery = window.location.search.toString();
        const newLocation = locationString.replace(currentQuery, '');
        window.history.replaceState("", "", newLocation);
    },
    /**
     * Set filter value for API data
     *
     * @param {string} key
     * @param {string} value
     */
    _setFilterValue(key, value) {
      this.queryObject.filterValues[key] = value;
    },

    resetSearch() {
      this._removeQueryFromUrl();
      //reset search text
      this.queryObject.q = '';
      this._setInitialCategories();
      this.getItems();
    },

    /**
     * Set query value for API data
     *
     * @param {string} value
     */
    setQueryValue(value) {
      this.queryObject.q = value;
    },

    onValueChosen(key, value) {
      this.activeIndex = 0;
      this._setFilterValue(key, value);
      this.getItems();
    },
	
	sortByColumn(key, value) {
	  this.sortBy = {};
	  this.sortBy[key] = value;
	  this.getItems();
	},
	
    updateSearchString: debounce(function(value) {
      this.activeIndex = 0;
      this.queryObject.q = value;
      this.getItems();
    }, 500),

    pageTo(newIndex) {
      this.activeIndex = newIndex;
      this.getItems();
    },
    buildQueryObject() {
      return {};
    },

    async getItems() {
      const queryObject = this.buildQueryObject();
      this.dataIsLoaded = false;

      const response = await CareersSearchService.getResults(
        this.queryObject,
        this.activeIndex,
        this.itemsPerPage,
		this.sortBy
      );
      this._processResponse(response);
      this.dataIsLoaded = true;
      this.changeUrl()
    },
    cleanObject(obj) {
      for (var propName in obj) { 
        if (obj[propName] === null || obj[propName] === undefined || obj[propName] === '') {
          delete obj[propName];
        }
      }
      return obj;
    },
    changeUrl() {
      // this._removeQueryFromUrl()
      const queryObjectWithSearchProp = Object.assign({}, this.queryObject.filterValues, {s: this.queryObject.q});
      this.cleanObject(queryObjectWithSearchProp);

      // set url to reflect filters and query
      let baseURL =
        location.protocol + "//" + location.host + location.pathname;
        baseURL += jsonToQueryString(queryObjectWithSearchProp);

      // set url params to allow for persistent searches
      window.history.replaceState("", "", baseURL);
    },

    _processResponse(response) {
      // copy filters
      this._copyOptionsToCategories(response.filterGroupItems);

      // copy items
      this.items = response.results;
    //   console.log('>>>> items: ',  this.items);

      this.total_count = response.totalItems;
	  
	  this.sortorder = this.sortBy;
	  
    },

    _copyOptionsToCategories(optionsByCategory) {
      for (let i = 0; i < this.filterCategories.length; i++) {
        const category = this.filterCategories[i];

        // find the options for this category and set them
        category.options = optionsByCategory[category.name];
		
		category.values =[];
		const Filvalue = category.values;
		if(category)
		{
		  if(category.options)
		   {
			for (let j = 0; j < category.options.length; j++)
			{
			if(category.options[j].isSelected && category.options[j].isSelected == true)
				{
				Filvalue.push(category.options[j]);
				}
			}
		   }	
		}
      }
    }
  }
};
</script>

<style lang="scss">
</style>

